const OrgStructureAssignmentsTableColumns = [
    { id: 'employee_name', labelAr: 'الموظف', labelEn: 'Employee' },
    { id: 'structure_item_name', labelAr: 'المنصب', labelEn: 'Position' },
    { id: 'school_name', labelAr: 'المدرسة', labelEn: 'School', width: 130 },
    { id: 'academic_year_name', labelAr: 'السنة', labelEn: 'Year', width: 120 },
    { id: 'starts_at', labelAr: 'من', labelEn: 'From', width: 110 },
    { id: 'ends_at', labelAr: 'إلى', labelEn: 'To', width: 110 },
    { id: 'is_active', labelAr: 'الحالة', labelEn: 'Status', width: 90 },
];

export default OrgStructureAssignmentsTableColumns;
